// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#layout-container {
    min-height: 100vh;
    max-width: 100vw;
    background: #f2f2f2;
    margin: auto;
    display: flex;
    flex-direction: column;
}

main {
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/fpp-app/layout/container.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB","sourcesContent":["#layout-container {\n    min-height: 100vh;\n    max-width: 100vw;\n    background: #f2f2f2;\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n}\n\nmain {\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
